import React, { useState, useEffect } from 'react'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import Typography from '@mui/material/Typography'

function Duplicates(props) {
    const [dimensions, setDimensions] = useState([])
    const [selectedDimension, setSelectedDimension] = useState({ "id":  -1, "name": "", "outputFormat": [], "ranges": [], "segments": [], "type": 1 })

    // trigger on component mount
    useEffect(() => {
        setDimensions(props.dimensions)

        if (props.selectedDimension && props.selectedDimension.id !== selectedDimension.id) {
            setSelectedDimension(props.selectedDimension)
        }
    }, [])

    useEffect(() => {
        if (props.selectedDimension && props.selectedDimension.id !== selectedDimension.id) {
            setSelectedDimension(props.selectedDimension)
        }
    }, [props.selectedDimension])

    return <>
        <Typography>Select the dimension you would like to aggregate duplicate values:</Typography>
        <Select
            value={selectedDimension["name"]}
            fullWidth
            onChange={(e) => {
                e.preventDefault()

                let newDimensionToSelect = e.target.value
                
                for (let x = 0; x < dimensions.length; x++) {
                    if (dimensions[x]["name"] === newDimensionToSelect) {
                        setSelectedDimension(dimensions[x])

                        if (props.onSave) {
                            props.onSave(dimensions[x])
                        }
                    }
                }
            }}>
                {dimensions.map((data, index) => {
                    return (data["id"] === -1) ? null : <MenuItem key={`duplicate-measure-${index}`} value={data["name"]}>{data["name"]}</MenuItem>
                })}
            </Select>
    </>
}

export default Duplicates